import React, { useRef } from 'react';
import { Modal , Map } from '../../../../../components';
import css from './DistanceMapModal.module.css';
import { useDispatch } from 'react-redux';
import { manageDisableScrolling } from '../../../../../ducks/ui.duck';

const DistanceMapModal = props => {
    const dispatch = useDispatch();
    const { isOpen, onClose, geolocation, address, title } = props;
    const mapRef = useRef(null);

    if (!isOpen || !geolocation) {
        return null;
    }

    return (
        <Modal
            id="DistanceMapModal"
            className={css.modal}
            containerClassName={css.modalContainer}
            isOpen={isOpen}
            onClose={onClose}
            usePortal
            lightCloseButton
            onManageDisableScrolling={(id, disableScrolling) => dispatch(manageDisableScrolling(id, disableScrolling))}
        >
            <div className={css.modalContent} onClick={e => e.stopPropagation()}>
                <div className={css.mapContainer}>
                    <Map
                        address={address}
                        center={geolocation}
                        useStaticMap={true}
                        ref={mapRef}
                    />
                </div>
            </div>
        </Modal>
    );
};

export default DistanceMapModal; 